module.exports = __webpack_public_path__ + "img/p4-mirror.10120cdb.png";